import React from 'react';
import { SaveAsPatchState } from './saveAsPatchModalState/SaveAsPatchModalState';
import { Modal } from 'antd';
import Text from 'components/Text/Text';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './index.module.scss';

interface IProps {
	onCloseModal: () => void;
}

export const SaveAsPatchModal: React.FC<IProps> = ({ onCloseModal }) => {
	return (
		<SaveAsPatchState>
			<Modal
				width="60%"
				bodyStyle={{ padding: '34px 40px 20px 40px' }}
				className={style.container}
				onCancel={onCloseModal}
				footer={null}
				visible={true}
				centered={false}
				destroyOnClose={true}
				closeIcon={
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#crossMark`} />
					</svg>
				}
				data-test="SaveAsPatchModal">
				<Text
					className={style.modalHeader}
					translationNameSpace="form"
					translationKey="patchChangesHeading"
					size="xxl"
					weight="bold"
				/>
				<Forms />
				<ModalWindows onCloseModal={onCloseModal} />
			</Modal>
		</SaveAsPatchState>
	);
};
